export default function handleErrorForThunk(err) {
  // Handle null or undefined errors
  if (!err) {
    return { error: "An unknown error occurred" };
  }
  
  // If error is already an object with error property, return it
  if (typeof err === 'object' && err.error && !err.message) {
    return err;
  }
  
  // If error has a message property, try to parse it
  if (err.message) {
    try {
      // Attempt to parse the error message in case it's JSON.
      const parsedError = JSON.parse(err.message);
      // If the parsed error is an object, use it; otherwise, wrap it in an object with an 'error' property.
      return typeof parsedError === "object" && parsedError !== null
        ? parsedError
        : { error: parsedError };
    } catch {
      // If parsing fails, use the message directly
      return { error: err.message };
    }
  }
  
  // If error is a string, wrap it
  if (typeof err === 'string') {
    return { error: err };
  }
  
  // If error is an object, try to extract meaningful information
  if (typeof err === 'object') {
    // Try to get error message from common properties
    const errorMessage = err.error || err.message || err.statusText || err.reason;
    if (errorMessage) {
      return { error: errorMessage };
    }
    // If no message found, stringify the object (but avoid "[object Object]")
    try {
      const stringified = JSON.stringify(err);
      return { error: stringified !== '{}' ? stringified : "An unknown error occurred" };
    } catch {
      return { error: "An unknown error occurred" };
    }
  }
  
  // Fallback
  return { error: "An unknown error occurred" };
}
